import React from 'react'
import {TreeItem} from '@mui/x-tree-view'

interface TreeViewComponentProps {
  node: any
}

export default function TreeViewNodeComponent({node}: TreeViewComponentProps) {
  return (
    <TreeItem itemId={String(node.id)} label={node.name}>
      {node.children != null &&
        node.children.length > 0 &&
        node.children.map((child: any) => <TreeViewNodeComponent node={child} key={child.id} />)}
    </TreeItem>
  )
}
